<script setup>
import { storeToRefs } from 'pinia'
import ProgressSpinner from 'primevue/progressspinner'
import { useUIStore } from '@/core/stores/ui.store'

const uiStore = useUIStore()
const { isLoading, loadingMessage } = storeToRefs(uiStore)
</script>

<template>
  <transition
    enter-active-class="transition-opacity duration-200 ease-out"
    leave-active-class="transition-opacity duration-200 ease-in"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isLoading"
      class="fixed inset-0 z-9999 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <div class="flex flex-col items-center gap-4 bg-white rounded-2xl p-8 shadow-2xl">
        <ProgressSpinner
          class="w-16! h-16!"
          stroke-width="4"
          animation-duration=".8s"
          aria-label="Loading"
        />
        <p
          v-if="loadingMessage"
          class="text-sm font-medium text-dss-surface-850 animate-pulse"
        >
          {{ loadingMessage }}
        </p>
      </div>
    </div>
  </transition>
</template>
